import { EnquiryTenantSettingsDto } from '@careapp-group/ng-sdk';
import { caCreateEntitySelectors } from '../../../store/entity-state/entity-selectors';
import {
  EnquiriesCategoryWrapper,
  EnquiriesTenantCategoryState,
} from './enquiries-tenant-categories.reducer';
import { createSelector } from '@ngrx/store';
import { Tenants } from '../../../store';
import { TenantSelectors } from '../../../store/tenants/tenants.selectors';

export const EnquiriesTenantCategorySelectors = caCreateEntitySelectors<
  EnquiriesCategoryWrapper,
  EnquiriesTenantCategoryState
>('enquiriesTenantCategories');

export const enquiriesCategoriesForSelectedTenant = createSelector(
  TenantSelectors.getSelectedId,
  EnquiriesTenantCategorySelectors.getPaginators,
  EnquiriesTenantCategorySelectors.getEntities,
  (id, paginators, entities) => {
    if (!id) {
      return [];
    }
    return paginators[id]?.ids?.map((id) => entities[id]) ?? [];
  },
);
